import CustomModal from "@components/CustomModal";

import useAdminPostManage from "./hooks/useAdminPostManage";
import AdminPostManageView from "./view";

export default function AdminPostManageModal({ modalRef }) {
    const {
        open,
        post,
        loading,
        handleClose,
        handleAddPoints,
        handleDeducePoints,
        handleDeletePost,
    } = useAdminPostManage({ modalRef });

    return (
        <CustomModal
            maxWidth={340}
            bottomButtonCancelText="Cancelar"
            hideSecondaryButton={false}
            loading={loading}
            title="Opções do post"
            handleSubmit={() => { }}
            open={open}
            handleClose={handleClose}
            width="100%"
            bodyComponent={
                open ? (
                    <AdminPostManageView
                        post={post}
                        loading={loading}
                        onAddPoints={handleAddPoints}
                        onDeducePoints={handleDeducePoints}
                        onDeletePost={handleDeletePost}
                    />
                ) : null
            }
        />
    );
}
